// eslint-disable-next-line sonarjs/slow-regex -- Disabled for plugin version update. Fix when possible
const UNIT_REGEX = /^(-?\d*\.?\d+)([a-zA-Z%]*)$/;

export const extractValueAndUnit = (
  input?: string,
): { value: number | undefined; unit: string | undefined } => {
  if (!input) return { value: undefined, unit: undefined };
  const match = UNIT_REGEX.exec(input);
  return match
    ? { value: parseFloat(match[1]), unit: match[2] || undefined }
    : { value: undefined, unit: undefined };
};

export const mergeValueAndUnit = (value: number, unit?: string): string => {
  if (!unit) return `${value}`;
  return `${value}${unit}`;
};
